import Head from "next/head";
import { useRouter } from "next/router";
function PageHeadScript({ extra = false }) {
  const router = useRouter();

  // URL se last slug nikalna
  const pathSegments = router.asPath.split("/").filter(Boolean);
  const lastSlug = pathSegments[pathSegments.length - 1] || "";

  let canonical = "";

  if (router.asPath.startsWith("/products")) {
    // Products pages
    canonical = `https://brunomd.com/products/${lastSlug}`;
  } else {
    // Landing pages
    canonical = `https://brunomd.com/${lastSlug}`;
  }
  return (
    <Head>
      {canonical && <link rel="canonical" href={canonical} />}

      <script
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-TVB3FKR');`,
        }}
      />
      {extra && (
        <>
          <script
            dangerouslySetInnerHTML={{
              __html: `(function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:1781499,hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`,
            }}
          />
          <script
            dangerouslySetInnerHTML={{
              __html: `!function (w, d, t) {
            w.TiktokAnalyticsObject = t; var ttq = w[t] = w[t] || []; ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"], ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))) } }; for (var i = 0; i < ttq.methods.length; i++)ttq.setAndDefer(ttq, ttq.methods[i]); ttq.instance = function (t) { for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)ttq.setAndDefer(e, ttq.methods[n]); return e }, ttq.load = function (e, n) {
              var i = 'https://analytics.tiktok.com/i18n/pixel/events.js';
              ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = i, ttq._t = ttq._t || {}, ttq._t[e] = +new Date, ttq._o = ttq._o || {}, ttq._o[e] = n || {};
              var o = document.createElement("script"); o.type = "text/javascript", o.async = !0, o.src = i + "?sdkid=" + e + "&lib=" + t; var a = document.getElementsByTagName("script")[0]; a.parentNode.insertBefore(o, a)
            };
            ttq.load('CFPRLK3C77U6J4U0JNP0');
            ttq.page();
          }(window, document, 'ttq');`,
            }}
          />{" "}
        </>
      )}
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TVB3FKR"
height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
        }}
      ></noscript>
      <script
        type="text/javascript"
        id="hs-script-loader"
        async
        defer
        src="//js.hs-scripts.com/19647191"
      ></script>
    </Head>
  );
}

export default PageHeadScript;
